export function calculateTotals(detailItems: BanHangRecord[] = []) {
  const tongSoLuong = detailItems.reduce((sum, item) => sum + (Number(item.so_luong) || 0), 0);
  const tongTienNt = detailItems.reduce((sum, item) => sum + (Number(item.tien_nt) || 0), 0);
  const tongTienNt2 = detailItems.reduce((sum, item) => sum + (Number(item.tien_nt2) || 0), 0);
  const tongChietKhau = detailItems.reduce((sum, item) => sum + (Number(item.ck_nt) || 0), 0);
  const tongThue = detailItems.reduce((sum, item) => sum + (Number(item.thue_nt) || 0), 0);
  const tongThanhToan = Math.round((tongTienNt2 + tongThue - tongChietKhau || 0) * 100) / 100;
  return { tongSoLuong, tongTienNt, tongTienNt2: tongTienNt2 - tongChietKhau, tongChietKhau, tongThue, tongThanhToan };
}

export const handleUpdateRowFields = (row: BanHangRecord, field: string, newValue: BanHangValue) => {
  if (
    field === 'so_luong' ||
    field === 'gia_nt2' ||
    field === 'tl_ck' ||
    field === 'ma_thue_data' ||
    field === 'gia_nt'
  ) {
    const so_luong = field === 'so_luong' ? newValue : row.so_luong;
    const gia_nt = field === 'gia_nt' ? newValue : row.gia_nt;
    const gia_nt2 = field === 'gia_nt2' ? newValue : row.gia_nt2;
    const tl_ck = field === 'tl_ck' ? newValue : row.tl_ck;
    const thue_suat = field === 'ma_thue_data' ? newValue?.thue_suat || 0 : row.ma_thue_data?.thue_suat || 0;

    const tien_nt2 = (Number(so_luong) || 0) * (Number(gia_nt2) || 0);
    const tien_nt = (Number(so_luong) || 0) * (Number(gia_nt) || 0);
    const ck_nt = (tien_nt2 * (Number(tl_ck) || 0)) / 100;
    const thue_nt = ((tien_nt2 - ck_nt) * (Number(thue_suat) || 0)) / 100;

    return {
      tien_nt2,
      ck_nt,
      thue_nt,
      tien_nt
    };
  }
  if (field === 'ma_vt_data') {
    return {
      ma_kho_data: newValue?.ma_kho_data || row.ma_kho_data,
      dvt: newValue?.dvt_nl_data?.uuid || newValue?.dvt_data?.uuid || row.dvt
    };
  }
  return {};
};
